import { type InstalledPlugin, pluginSkillResourceUri } from '@crowdex/plugin-contracts';
import type { AvailablePluginSkill } from './types';

/**
 * Flatten the enabled plugins into the skills exposed to the composer and the
 * skill directories advertised to the agent. Disabled plugins contribute
 * nothing. Pure: derived solely from the installed plugin list.
 */
export function collectPluginSkills(
  installedPlugins: readonly InstalledPlugin[],
): AvailablePluginSkill[] {
  const skills: AvailablePluginSkill[] = [];
  for (const plugin of installedPlugins) {
    if (!plugin.enabled) continue;
    for (const skill of plugin.skills) {
      skills.push({
        ...skill,
        pluginName: plugin.name,
        pluginDisplayName: plugin.displayName,
        uri: pluginSkillResourceUri(plugin.name, skill.name),
      });
    }
  }
  return skills;
}

/**
 * A saved agent's skills, named in its instructions as composer references: the workspace server
 * gives the agent each one whole, from its file (no copy travels with the conversation).
 */
export function skillReferences(refs: readonly { name: string; uri: string }[]): string {
  return refs.length === 0
    ? ''
    : `Skills this agent always works with: ${refs.map((ref) => `[$${ref.name}](${ref.uri})`).join(', ')}.`;
}
